<!-- Expired / disabled external share links -->
<div class="offset-md-4 col-md-4 mt-4" *ngIf="!(user && account) || error">
    <div class="card">
      <div class="card-body text-center">

        <!-- Disabled share link message -->
          <div *ngIf="error && error.status == 403 && isShare">
               <p><fa-icon icon="times-circle" size="4x" class="text-danger"></fa-icon></p>
               <h3 translate>SHARES.DISABLED</h3>
              <p> {{ 'SHARES.DISABLED_TEXT' | translate }}</p>
          </div>

          <!-- Error message -->
          <div *ngIf="!loading && ((error && error.status != 403))">
              <p><fa-icon icon="times-circle" size="4x" class="text-danger"></fa-icon></p>
              <h3 translate>GENERIC.ERROR</h3>
              <p>{{ error.message }}</p>
          </div>

          <!-- Verifying... -->
          <div *ngIf="loading" translate>
             GENERIC.VERIFY
          </div>
           <mat-progress-bar mode="indeterminate" *ngIf="loading" class="abs-bottom"></mat-progress-bar>
        </div>

    </div>
</div>



<div class="fullscreen" *ngIf="!loading && !error && user && account">
  <div class="row justify-content-center m-0 auth-box mt-2">
      <div class="col-sm-4 p-0">

          <!-- Logo-->
          <mat-card class="p-0">
              <div class="d-flex justify-content-center pt-3">
                  <div class="logo-wrapper">
                    <img class="logo-img" src="{{service.V.config.host + '/4dinfo/image.png'}}">
                  </div>
              </div>

              <!-- Activate your account message-->
              <div class="d-flex justify-content-center">
                      <h3 class="text-center mt-4">{{ 'SIGNIN.ACTIVATE' | translate }}</h3>
              </div>

               <!-- Activate your account progress bar-->
              <mat-card-content class="p-4 text-center" *ngIf="(!error && !user) || loading">
                  <mat-progress-bar mode="indeterminate" ></mat-progress-bar>
              </mat-card-content>

              <mat-card-content class="p-4 text-center">

                   <!-- 'To complete your set up, please fill out all form fields below' message -->
                  <div  class="mb-2" translate>SIGNIN.FINISH_DETAILS</div>
                  
                  <!-- Error message-->
              

                  <!-- Team/company account name -->
                  <mat-form-field class="w-100" *ngIf="!user.account">
                      <mat-icon matPrefix class="mr-2">account_box</mat-icon>
                      <input matInput #aname="ngModel" type="text" name="aname" placeholder="{{'SIGNIN.ACC_NAME_PLACEHOLDER' | translate }}" [(ngModel)]="account.name" required >
                  </mat-form-field>

                  <!-- Terms and conditions link and check box -->
                  <div class="mt-2 mb-2 text-left">
                      <mat-checkbox [(ngModel)]="terms">{{ 'SIGNIN.TERMS' | translate }}</mat-checkbox><br/>
                      <a class="ml-4" target="_new"  href="{{ 'SIGNIN.TERMS_link' | translate }}">{{ 'SIGNIN.TERMS_link_text' | translate }}</a>  
                  </div>

                  <!-- Activate new account button -->
                    <button (click)="activate()" mat-raised-button color="primary" type="submit" class="w-100 m-0" [disabled]="loading || !terms || !account.name">{{ 'SIGNIN.ACTIVATE_BTN' | translate }}</button>
               
              </mat-card-content>
              <!--<mat-card-actions class="m-0 p-4"> </mat-card-actions -->
           

               <!-- Error message -->
              <mat-card-content class="p-4 text-center" *ngIf="!user && error">
                  <fa-icon icon="exclamation-triangle" size="4x" class="text-danger"></fa-icon>
                  <div translate class="mt-2 mb-2">ERROR.{{ error.status }}</div>
              </mat-card-content>

          </mat-card>
      </div>
  </div>
</div>
